import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

export const formatConfigUnmarshaller = {
  marginTop: builder.number('creative_margin_top', {
    defaultValue: 0,
    d:'',
    unit: units.pixel
  }),
  skanTimeout: builder.number('skan_timeout', {
    defaultValue: 15,
    d:''
  })
};
